module.exports = __webpack_public_path__ + "static/media/Transactionblack.6d17d06d.svg";